export default {
    name: 'B1',
    lineHeight: '40px',
    lineHeightDesktop: '60px',
  }